import React, { useState } from 'react';

const faqs = [
  {
    question: "What is a Digital Product Passport (DPP)?",
    answer: "A Digital Product Passport (DPP) is a digital profile connected to a physical product that stores information such as origin, materials, sustainability data, and lifecycle history, accessible through a QR code or RFID tag."
  },
  {
    question: "Who must comply with DPP regulations?",
    answer: "DPP regulations apply to manufacturers, importers, and distributors selling products within the EU market, including sectors such as electronics, batteries, textiles, home appliances, and FMCG."
  },
  {
    question: "What is ESPR and its connection to DPP?",
    answer: "The Ecodesign for Sustainable Products Regulation (ESPR) is an EU framework requiring Digital Product Passports for regulated product categories entering the European market."
  },
  {
    question: "How does Provinyx generate Digital Product Passports?",
    answer: "Provinyx assigns each product a secure digital identity linked to a QR code or RFID tag, with lifecycle data stored on blockchain-backed infrastructure for instant verification and traceability."
  },
  {
    question: "Which industries does Provinyx support?",
    answer: "Provinyx supports industries including electronics, home appliances, FMCG, cosmetics, and luxury goods - especially businesses requiring EU DPP compliance and product authentication."
  },
  {
    question: "How does Provinyx help prevent counterfeiting?",
    answer: "Each product is assigned a tamper-resistant digital identifier that enables instant authenticity verification through secure QR code scanning across the supply chain."
  },
 {
    question: "How can businesses get started with Provinyx?",
    answer: "Schedule a free demo with the Provinyx team to evaluate your compliance requirements and implement a scalable Digital Product Passport solution ahead of EU deadlines."
  }
];

const FAQ = () => {

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-blue-25 text-gray-900 py-16 px-6 font-sans">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-14 tracking-wide">
          Frequently Asked Questions
        </h2>
        
        <div className="border-t border-gray-200 pt-2">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              
              className={`py-5 px-5 my-1 transition-all duration-300 border rounded-xl ${
                openIndex === index 
                  ? 'border-blue-500 bg-white shadow-sm' 
                  : 'border-transparent border-b-gray-200 hover:border-blue-500 hover:bg-white hover:shadow-sm'
              }`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex justify-between items-center text-left focus:outline-none"
              >
                <span className={`text-lg md:text-xl font-medium tracking-wide transition-colors duration-300 ${openIndex === index ? 'text-blue-600' : 'text-gray-900'}`}>
                  {faq.question}
                </span>
                <span className={`text-2xl font-light ml-4 transition-colors duration-300 ${openIndex === index ? 'text-blue-600' : 'text-gray-500'}`}>
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              
              {openIndex === index && (
                <div className="mt-4 text-gray-600 text-base md:text-lg leading-relaxed pr-8">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;